// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empprofilesection-inline-1 {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.empprofilesection-inline-2 {
  font-size: 16px;
  font-weight: 700;
  font-family: 'Plus Jakarta Sans',sans-serif;
}

.empprofilesection-inline-3 {
  font-size: 12px;
  color: #64748b;
}

.empprofilesection-inline-4 {
  font-size: 11px;
  color: #94a3b8;
}

.empprofilesection-inline-5 {
  text-align: center;
  color: #94a3b8;
  padding: 20px;
  font-size: 13px;
}

.empprofilesection-inline-6 {
  cursor: pointer;
}

.emp-skill-box {
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.emp-edit-box {
  display: grid;
  gap: 10px;
  padding: 16px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.05);
}

.emp-edit-hint {
  font-size: 14px;
  color: #475569;
  font-weight: 600;
}

.emp-edit-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}

.emp-edit-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.emp-edit-box .fl {
  font-size: 14px;
  font-weight: 700;
  color: #334155;
}

.emp-edit-box .fi {
  font-size: 18px;
  color: #1e293b;
  background: #f8fafc;
}

.emp-skill-add-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
}

.emp-skill-hint {
  font-size: 12px;
  color: #64748b;
}

.emp-suggested-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.emp-suggested-chip {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  font-size: 12px;
  border-radius: 14px;
  padding: 4px 10px;
  cursor: pointer;
}

.emp-suggested-chip:disabled {
  opacity: .55;
  cursor: not-allowed;
}

.emp-skill-list {
  display: grid;
  gap: 8px;
}

.emp-skill-empty {
  font-size: 12px;
  color: #94a3b8;
  padding: 8px 4px;
}

.emp-skill-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 10px;
}

.emp-skill-item-text {
  font-size: 13px;
  color: #0f172a;
  font-weight: 600;
}

.emp-skill-item-actions {
  display: flex;
  gap: 6px;
}

.emp-skill-edit-input {
  min-width: 180px;
}

.emp-inline-note {
  margin: 4px 0 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #eef5ff;
  border: 1px solid #c7dcff;
  color: #1e3a8a;
  font-size: 13px;
  font-weight: 600;
}

.profile-value-inline-edit {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.emp-inline-input {
  max-width: 360px;
  min-height: 40px;
  font-size: 15px;
  text-align: left;
}

.emp-inline-edit-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.emp-inline-edit-btn:hover {
  background: #dbeafe;
  border-color: #93c5fd;
}

.emp-inline-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

@media (max-width: 640px) {
  .emp-edit-grid {
    grid-template-columns: 1fr;
  }

  .emp-skill-add-row {
    grid-template-columns: 1fr;
  }

  .emp-skill-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .emp-skill-item-actions {
    width: 100%;
  }

  .profile-value-inline-edit {
    width: 100%;
    justify-content: flex-start;
  }

  .emp-inline-input {
    max-width: 100%;
    width: 100%;
  }

  .emp-inline-actions {
    flex-wrap: wrap;
  }



.avatar-upload-wrapper {
  position: relative; 
  display: inline-block;
}

.avatar-upload-wrapper [class*="modal-backdrop"], 
.avatar-upload-wrapper [class*="overlay"] {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 250px !important; 
  height: 250px !important;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(2px);
  z-index: 100;
}

.avatar-upload-wrapper [class*="modal-content"], 
.avatar-upload-wrapper [class*="popup"] {
  position: absolute !important;
  top: 70px !important; 
  left: 0 !important;
  width: 220px !important;
  transform: none !important;
  box-shadow: 0 8px 30px rgba(0,0,0,0.15) !important;
  border: 1px solid #e2e8f0 !important;
  padding: 10px !important;
  border-radius: 12px !important;
  background: white !important;
}

.avatar-upload-wrapper [class*="modal-content"] img {
  width: 80px !important;
  height: 80px !important;
  margin-bottom: 10px;
}

.avatar-upload-wrapper [class*="modal-content"] button {
  padding: 5px 10px !important;
  font-size: 12px !important;
}
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpProfileSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;;;AAIF;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,+CAA+C;EAC/C,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,kDAAkD;EAClD,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA","sourcesContent":[".empprofilesection-inline-1 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.empprofilesection-inline-2 {\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Plus Jakarta Sans',sans-serif;\n}\n\n.empprofilesection-inline-3 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.empprofilesection-inline-4 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.empprofilesection-inline-5 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 20px;\n  font-size: 13px;\n}\n\n.empprofilesection-inline-6 {\n  cursor: pointer;\n}\n\n.emp-skill-box {\n  display: grid;\n  gap: 10px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.emp-edit-box {\n  display: grid;\n  gap: 10px;\n  padding: 16px;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.05);\n}\n\n.emp-edit-hint {\n  font-size: 14px;\n  color: #475569;\n  font-weight: 600;\n}\n\n.emp-edit-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 12px;\n}\n\n.emp-edit-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.emp-edit-box .fl {\n  font-size: 14px;\n  font-weight: 700;\n  color: #334155;\n}\n\n.emp-edit-box .fi {\n  font-size: 18px;\n  color: #1e293b;\n  background: #f8fafc;\n}\n\n.emp-skill-add-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px;\n}\n\n.emp-skill-hint {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.emp-suggested-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.emp-suggested-chip {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  border-radius: 14px;\n  padding: 4px 10px;\n  cursor: pointer;\n}\n\n.emp-suggested-chip:disabled {\n  opacity: .55;\n  cursor: not-allowed;\n}\n\n.emp-skill-list {\n  display: grid;\n  gap: 8px;\n}\n\n.emp-skill-empty {\n  font-size: 12px;\n  color: #94a3b8;\n  padding: 8px 4px;\n}\n\n.emp-skill-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 8px 10px;\n}\n\n.emp-skill-item-text {\n  font-size: 13px;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.emp-skill-item-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.emp-skill-edit-input {\n  min-width: 180px;\n}\n\n.emp-inline-note {\n  margin: 4px 0 8px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #eef5ff;\n  border: 1px solid #c7dcff;\n  color: #1e3a8a;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.profile-value-inline-edit {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.emp-inline-input {\n  max-width: 360px;\n  min-height: 40px;\n  font-size: 15px;\n  text-align: left;\n}\n\n.emp-inline-edit-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #1d4ed8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.emp-inline-edit-btn:hover {\n  background: #dbeafe;\n  border-color: #93c5fd;\n}\n\n.emp-inline-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n@media (max-width: 640px) {\n  .emp-edit-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .emp-skill-add-row {\n    grid-template-columns: 1fr;\n  }\n\n  .emp-skill-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .emp-skill-item-actions {\n    width: 100%;\n  }\n\n  .profile-value-inline-edit {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .emp-inline-input {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .emp-inline-actions {\n    flex-wrap: wrap;\n  }\n\n\n\n.avatar-upload-wrapper {\n  position: relative; \n  display: inline-block;\n}\n\n.avatar-upload-wrapper [class*=\"modal-backdrop\"], \n.avatar-upload-wrapper [class*=\"overlay\"] {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 250px !important; \n  height: 250px !important;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.8) !important;\n  backdrop-filter: blur(2px);\n  z-index: 100;\n}\n\n.avatar-upload-wrapper [class*=\"modal-content\"], \n.avatar-upload-wrapper [class*=\"popup\"] {\n  position: absolute !important;\n  top: 70px !important; \n  left: 0 !important;\n  width: 220px !important;\n  transform: none !important;\n  box-shadow: 0 8px 30px rgba(0,0,0,0.15) !important;\n  border: 1px solid #e2e8f0 !important;\n  padding: 10px !important;\n  border-radius: 12px !important;\n  background: white !important;\n}\n\n.avatar-upload-wrapper [class*=\"modal-content\"] img {\n  width: 80px !important;\n  height: 80px !important;\n  margin-bottom: 10px;\n}\n\n.avatar-upload-wrapper [class*=\"modal-content\"] button {\n  padding: 5px 10px !important;\n  font-size: 12px !important;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
